import Main from '@/views/main.vue'

import {tailGasMenuRouter} from './tailGas'

const gasMenuRouter = {
  // 权限
  has: 'tailGasCheck',
  path: '/',
  icon: 'android-people',
  name: 'tailGasMenuRouter',
  title: '尾气检验单',
  component: Main,
  children: [
    ...tailGasMenuRouter
  ]
}

export {gasMenuRouter}



// WEBPACK FOOTER //
// ./src/router/gas/index.js